// Pure decision for the rep Paid/Pending toggle. No side effects.
// Kept separate from RepPortal.js so the ordering (both invoices are looked up
// BEFORE either is read) is unit-testable. A cancelled invoice is terminal.
// An invoice the company already received from the rep (an active remittance,
// or a cache invoice paid via a rep remittance) can NOT be toggled by the rep.
import { REMIT_PAID_VIA, REP_TOGGLE_REFUSAL } from "./repRemittances";

export function decideToggle(localInvoice, sharedInvoice, activeRemittance) {
  if (!localInvoice && !sharedInvoice) return { action: "none", reason: "missing" };
  if ((localInvoice && localInvoice.status === "cancelled") || (sharedInvoice && sharedInvoice.status === "cancelled")) {
    return { action: "none", reason: "cancelled" };
  }
  if (activeRemittance || (localInvoice && localInvoice.paidVia === REMIT_PAID_VIA) || (sharedInvoice && sharedInvoice.paidVia === REMIT_PAID_VIA)) {
    return { action: "none", reason: "company_received", message: REP_TOGGLE_REFUSAL };
  }
  const current = (localInvoice && localInvoice.status) || (sharedInvoice && sharedInvoice.status) || "pending";
  return { action: "toggle", currentStatus: current, nextStatus: current === "paid" ? "pending" : "paid" };
}
